import { type ComponentProps, createElement, type ElementType } from "react";
import { cn } from "../../lib/utils";

/** Cyra's shared DOM/accessible-headless adapter; styles live in global.css. */
export function surface<T extends ElementType>(Tag: T, slot: string, styles = "") {
  return function Surface({
    className,
    ...props
  }: ComponentProps<T> & { className?: string | undefined }) {
    return createElement(Tag, { ...props, "data-slot": slot, className: cn(styles, className) });
  };
}
